import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Utility from '../../services/utility.service';
import Loader from './../../../shared/components/loader'
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Util from '../../../shared/util/util';
import BookingService from '../../../cargobooking/services/cargobooking.service';
import XLSX from 'xlsx';

export default {
    name: 'MPSList',
    components: {
        CustomExpandableTable,
        Util,
        Utility,
        Loader,
        BookingService,
        XLSX
    },
    data: function () {
        return {
            totalCount: 0,
            offset: 0,
            SearchValue:"",
            SearchType:"parentawb",
            isLoading:false,
            tableData:[],
            source:"",
            MpsCount:"",
            showtable:false
        }
    },
    computed: {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
    },
    methods: {
        clearForm() {
          this.SearchValue = "";
          this.SearchType = "parentawb";
          this.showtable = false;
          this.tableData =[];
          this.$validator.reset();
        },
        async search(){      
            try{
                  this.tableData = [];
                  this.isLoading=true;
                  let inputPayload = {
                    SearchValue:this.SearchValue,
                    SearchType:this.SearchType
                  };
                  let result = await BookingService.PrintMpsStickers(inputPayload);
                    if(result.data.code==200){
                    this.MpsCount = result.data.data.noofmps;
                    this.ClientName = result.data.data.clientname;
                    this.RouteMode =result.data.data.routemode;
                    this.source =result.data.data.originhubname;
                    this.parentawbno = result.data.data.parentawbno;
                    this.destination =result.data.data.destinationhunname;
                    result.data.data.childmps.forEach((item, i) => {
                      this.tableData.push(result.data.data.childmps[i]);
                    });
                    this.isLoading=false;
                    this.showtable = true
                  }
                  else {
                    this.isLoading=false;
                    this.$alert(result.data.message,"","error")
                  }
            }
            catch(err){
              this.$alert(err,"","error");
            }
          },
        async downloadMPSList(){
            try {
              this.isLoading = true;
              var downloadMPS =[];
              let inputPayload = {
                SearchValue:this.SearchValue,
                SearchType:this.SearchType
              };
              let result = await BookingService.PrintMpsStickers(inputPayload);
              if(result.data.code==200){
                result.data.data.childmps.forEach((item, i) => {
                  result.data.data.childmps[i].AWB = result.data.data.parentawbno;
                  result.data.data.childmps[i].ClientName = result.data.data.clientname;
                  result.data.data.childmps[i].RouteMode = result.data.data.routemode;
                  result.data.data.childmps[i].Source =result.data.data.originhubname;
                  result.data.data.childmps[i].DestinationHubName =result.data.data.destinationhunname;
                    downloadMPS.push(result.data.data.childmps[i]);
                  });
                const data = XLSX.utils.json_to_sheet(downloadMPS);
                data['!cols'] = [];
                data['!cols'][1] = { hidden: true };
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, data, 'data')
                XLSX.writeFile(wb,'DownloadMPSList.xlsx');
              }else{
                this.$alert("No MPS records to download", "MPS List", "error");
              }
              this.isLoading = false;
            } catch(err){
              console.log(err);
              this.isLoading = false;
            }
          },
          onSubmit: function(event) {
            this.$validator.validateAll().then((result) => {
              if(result){
                this.search(event);
              }
            }).catch(() => {
              console.log('errors exist', this.errors)
            });
          },
    }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/mpslist/mpslist.component.js